import { createSlice } from '@reduxjs/toolkit';

import { reducers } from './reducers';
import { SliceState } from './slice-state';

const initialState: SliceState = {
    mccLookupShown: false,
    mccLookupData: [],
};

const sliceObj = createSlice({
    name: 'slice-name',
    initialState,
    reducers,
});

export const ToolsSlice = sliceObj.reducer;

export const { setHealthData, setSeamHealth, setMccLookupVisible, setMccLookupData } = sliceObj.actions;
